import axios from "axios"



const next_api = axios.create({
    withCredentials: true,
    baseURL: process.env.NEXT_PUBLIC_URL + "/api",
})

next_api.interceptors.request.use((config) => {
    config.headers.Authorization = `Bearer ${localStorage.getItem("token")}`;
    config.headers['CustomerAuthentication-Token'] = `Bearer ${localStorage.getItem("token")}`;
    return config
  })

export default next_api